import {createStore, combineReducers, applyMiddleware} from 'redux'
import pokemonReducer from './reducers/pokemonReducer'
import thunk from 'redux-thunk'

const favoriteChangeNotif = store => next => action => {
    if (action.type === "SET_FAVORITES") {
      console.log("New pokemon add to favorite!");
      next(action);
    } 
    else if (action.type === "DEL_FAVORITES") {
      console.log("Delete one pokemon from favorite list")
      next(action);
    } 
    else {
      next(action)
    }
};

const reducers = combineReducers({ pokemonReducer })

const store = createStore(reducers, applyMiddleware(thunk,favoriteChangeNotif));

export default store;